module.exports = __webpack_public_path__ + "img/pe08.5da034bd.jpg";